export enum MarketingShotStatusEnum {
    DRAFT = 'DRAFT',
    SCHEDULED = 'SCHEDULED',
    SENDING = 'SENDING',
    SENT = 'SENT',
    ERROR = 'ERROR',
}
